<template>
	<div class="nakladnoyWholesale">
		<div class="actions mb-2 mt-2 hidden-print">
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{
						$t('back')
					}}
				</b-button>

			</div>
			<div class="pull-right">
<!--				<b-button-->
<!--					variant="outline-dark"-->
<!--					class="mr-2"-->
<!--				>-->
<!--					<i class="fa fa-print"></i>-->
<!--					{{ $t('pricing.print') }} {{ $t('goods.barcode') }}-->
<!--				</b-button>-->
				<b-button
					variant="outline-dark"
					@click="print"
					class="mr-2"
				>
					<i class="fa fa-print"></i>
					{{ $t('Печать') }}
				</b-button>
			</div>
		</div>
		<br>
		<br>
		<div class="doc-body">
			<b-card class="p-1">
				<h1 class="text-center">{{ $t('incomes.aktExpertize') }}</h1>
				<b-row>
					<b-col cols="4"></b-col>
					<b-col cols="4">
						<b-row>
							<b-col align="center">
								<span><b>{{ $t('incomes.name') }}</b> {{ document.regNumber }}</span>
							</b-col>
							<b-col align="center">
								<span class=""><b>{{ $t('incomes.date') }}:</b> {{ document.regDate }}</span>
							</b-col>
						</b-row>
					</b-col>
					<b-col cols="4"></b-col>
				</b-row>
				<div style="padding-left: 10%; padding-right: 10%">
					<table class="table table-hover table-bordered table-striped mt-3" id="table">
						<thead>
						<tr>
							<th class="p-1 text-center">№</th>
							<th class="p-1 text-center">{{ $t('goods.name') }}</th>
							<th class="p-1 text-center">{{ $t('goods.special-barcode') }}</th>
							<th class="p-1 text-center">{{ $t('goods.barcode') }}</th>
							<th class="p-1 text-center">Кол-во на приход</th>
							<th class="p-1 text-center">{{ $t('sale.kol-vo') }}</th>
							<th class="p-1 text-center">{{ $t('goods.create.unit') }}</th>
						</tr>
						</thead>
						<tbody>
						<tr v-for="(item, index) in document.whItems">
							<td class="p-1 text-center">{{ index + 1 }}</td>
							<td class="p-1">{{ item.itemName }}</td>
							<td class="p-1 text-center"><b>{{ item.barcode }}</b></td>
							<td class="p-1 text-center"><p v-for="t in item.multiBarcodes">{{ t.barcode }}</p></td>
							<td class="p-1 text-center">{{ item.count }}</td>
							<td class="p-1 text-center">{{ item.temporaryQty }}</td>
							<td class="p-1 text-center">{{ item.unitName }}</td>
						</tr>
						</tbody>
					</table>
				</div>
				<b-row style="padding-left: 10%; padding-right: 10%; margin-top: 10%">
					<b-col cols="6"></b-col>
					<b-col cols="6" align-self="center">
						<b-row align-content="center" v-for="(user, index) in document.userAndWhDocuments" :key="`users-${index}`" class="mt-3">
							<b-col cols="5" style="text-align: right"><h5>{{ user.employeeName }} :</h5></b-col>
							<b-col cols="7">
								<b-row>
									<b-col cols="4" align="center" v-if="$route.params.action == 'edit' && document.employeeId == user.employeeId">
										<b-button size="sm" @click="saveAkt" :disabled="loadingBtn"
												  variant="success">
											{{ $t('incomes.approve') }}
											<b-spinner v-if="loadingBtn" small></b-spinner>
										</b-button>
									</b-col>
									<b-col cols="4" align="center" v-if="$route.params.action == 'edit' && document.employeeId == user.employeeId">
										<b-button size="sm" @click="comment = true" :disabled="comment"
												  variant="danger">
											{{ $t('actions.cancel') }}
											<b-spinner v-if="comment" small></b-spinner>
										</b-button>
									</b-col>
									<b-col cols="4" align="center" v-if="$route.params.action == 'edit' && document.employeeId != user.employeeId && user.status == 'APPROVED'">
										<b-button size="sm" disabled variant="success">
											<i class="fa fa-check"></i>
										</b-button>
									</b-col>
									<b-col cols="4" align="center" v-if="$route.params.action == 'edit' && document.employeeId != user.employeeId && user.status == 'REJECTED'">
										<b-button size="sm" disabled variant="danger">
											<i class="fa fa-close"></i>
										</b-button>
									</b-col>
									<b-col cols="2" align="center" v-if="$route.params.action == 'edit' && document.employeeId != user.employeeId && !user.status">
										<b-button size="sm" disabled variant="warning">
											<i>...</i>
										</b-button>
									</b-col>
									<b-col cols="2" align="center" v-if="$route.params.action == 'view' && user.status == 'APPROVED'">
										<b-button size="sm" disabled variant="success">
											<i class="fa fa-check"></i>
										</b-button>
									</b-col>
									<b-col cols="2" align="center" v-if="$route.params.action == 'view' && user.status == 'REJECTED'">
										<b-button size="sm" disabled variant="danger">
											<i class="fa fa-close"></i>
										</b-button>
									</b-col>
									<b-col cols="2" align="center" v-if="$route.params.action == 'view' && !user.status">
										<b-button size="sm" disabled variant="warning">
											<i>...</i>
										</b-button>
									</b-col>
									<b-col cols="2" align="left" v-if="user.status == 'REJECTED'">
										<b-button size="sm" variant="primary" @click="commentViews(user)"><i class="fa fa-eye"></i>
										</b-button>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
				<b-modal
					v-model="comment"
					centered
					:title="$t('incomes.reason')"
				>
					<b-form-textarea v-model="document.reason" rows="3"
									 :placeholder="$t('incomes.reason')"></b-form-textarea>
					<template #modal-footer>
						<b-button size="sm" variant="success" @click="cancelAkt()">
							{{ $t('actions.save') }}
						</b-button>
						<b-button size="sm" variant="danger" @click="comment = false">
							{{ $t('actions.cancel') }}
						</b-button>
					</template>
				</b-modal>
				<b-modal
					v-model="commentView"
					centered
					hide-footer
					:title="$t('incomes.reason')"
				>
					<b-form-textarea v-model="document.reason" disabled rows="3"
									 :placeholder="$t('incomes.reason')"></b-form-textarea>
				</b-modal>
			</b-card>
		</div>
	</div>
</template>

<script>
import WhDocument from "@/services/wh-document.service";

export default {
	name: 'ActEcpration',
	components: {},
	data() {
		return {
			document: {},
			loadingBtn: false,
			comment: false,
			commentView: false,
		}
	},
	computed: {},
	methods: {
		commentViews(user) {
			this.document.reason = user.comment
			this.commentView = true
		},
		goBackToFrom() {
			this.$router.back();
		},
		print() {
			window.print();
		},
		async saveAkt() {
			this.loadingBtn = true
			await WhDocument.saveAkt(this.$route.params.id, '').then(res => {
				this.loadingBtn = false
				this.$router.go(-1)
			})
		},
		async cancelAkt() {
			await WhDocument.cancelAkt(this.$route.params.id, this.document.reason).then(res => {
				this.comment = false
				this.$router.go(-1)
			})
		}
	},
	async created() {
		await WhDocument.get(this.$route.params.id).then(res => {
			this.document = res.data
		})
	},
	watch: {}
}
</script>

<style scoped lang="scss">
.spinner-wrapper {
	position: absolute;
	background: rgba(32, 28, 32, 0.49);
	left: 0;
	right: 0;
	text-align: center;
	top: 0;
	bottom: 0;
	padding-top: 35px;
	z-index: 5;
}

.nakladnoyWholesale {
	margin: 0 20px;
}

@media print {
	.hidden-print {
		display: none;
	}
	.mt {
		padding-top: 200px !important;
	}
	.card {
		box-shadow: none;
	}
	#nakladnoyTableWrapper {
		display: block;
	}
}

.saldoInfoTexts {
	width: 88%;

	span {
		display: inline-block;
		width: 18%;
	}

	input.bottomBorderedInput {
		outline: 0;
		border-width: 0 0 .5px;
		border-color: black;
		width: 80%;
	}

	/*input.bottomBorderedInput:focus {
	border-color: green
	}*/
}


.signsOfAccountants {
	input.bottomBorderedInput {
		outline: 0;
		border-width: 0 0 .5px;
		border-color: black;
		width: 40%;
	}

	p {
		width: 40%;

		&.sign {
			text-align: center;
			font-size: 12px;
		}
	}
}

input.bottomBorderedInput {
	outline: 0;
	border-width: 0 0 .5px;
	border-color: black;

	&.width70 {
		width: 70px;
	}

	&.width80 {
		width: 80px;
	}

	&.forDate {
		width: 40px;
		text-align: right;

		&.borderRed {
			border-color: red;
			color: red;
		}
	}
}

h6.bottomBorderedInput {
	outline: 0;
	border-width: 0 0 .5px;
	border-color: black;

	&.width70 {
		width: 70px;
	}

	&.width80 {
		width: 80px;
	}

	&.forDate {
		width: 40px;
		text-align: right;

		&.borderRed {
			border-color: red;
			color: red;
		}
	}
}

#nakladnoyTableWrapper {
	.table {
		td, th {
			border: 1px solid black;
			vertical-align: middle;

			&.borderRightNone {
				border-right: none;
			}

			&.borderLeftNone {
				border-left: none;
			}

			&.borderTopNone {
				border-top: none;
			}

			&.borderBottomNone {
				border-bottom: none;
			}

			color: black;
		}

		#moldavianItemsHeader {
			th {
				font-size: 9px;
				border-bottom: none;
			}

			.width27 {
				width: 27%;
			}
		}

		#russianItemsHeader {
			th {
				font-size: 9px;
				border-top: none;
			}

			.greyText {
				color: #999999;
			}
		}

		.docItemRow {
			td {
				text-align: right;

				&.docItemUnit {
					text-align: center;
				}

				&:first-child {
					text-align: unset;
				}

				padding: 0 .5rem;
			}
		}

		th {
			font-size: 11px;
		}


		.moldavianText {
			font-weight: bold;
		}

		.fontWeightNormal {
			font-weight: normal;
		}

		tfoot {
			th, td {
				font-weight: bold;
				font-size: 11px;
				text-align: right;

				&.textAlignCenter {
					text-align: center;
				}

				&:first-child {
					text-align: unset;
				}

				padding: 0 .5rem;
			}
		}
	}
}

.customSize {
	font-size: 10px;
}

.customSizeItem {
	font-size: 12px;
}

.nobr {
	white-space: nowrap;
}

.strong {
	font-weight: bold;
}

#docUpperPart {
	p {
		margin-bottom: 0;
	}

	margin-bottom: .5rem;

	#docImgLogoName {
		margin-left: 32%;
		width: 300px;
		height: auto;
	}

	#docImgLogo {
		width: 180px;
		height: 70px;
	}

	#docUpperPartLeft {
		#docUpperPartTxt {
			margin-top: .5rem;
			display: inline-block;
			width: 30%;

			p {
				display: inline-block;
			}
		}

		#barcodeImgForSeria {
			cursor: pointer;
			display: inline-block;
			width: 30%;

			svg {
				vertical-align: bottom;
				width: 46mm !important;
				height: auto !important;

				g {
					text {
						font-size: 14px !important;
						transform: translateY(46px) !important;
					}
				}
			}
		}

		display: inline-block;
		width: 74%;

		#seriaInputForBarcode {
			display: inline-block;

			input {
				margin-left: .5rem;
				width: 10rem;
				height: 1.2rem;
			}
		}
	}

	#docUpperPartRight {
		display: inline-block;
		width: 26%;
		vertical-align: top;
		text-align: right;

		#rightPartTxt {
			font-size: 10px;
		}
	}
}
</style>
